module.exports = __webpack_public_path__ + "img/2021_10_dande_kitanotenmangu3_1020_fin_web.2ddafe17.png";